// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * @deprecated The @microsoft/applicationinsights-common package has been merged
 * into @microsoft/applicationinsights-core-js for simplified dependency management
 * and improved tree-shaking capabilities.
 *
 * Please migrate your imports from "@microsoft/applicationinsights-common" to
 * "@microsoft/applicationinsights-core-js".
 *
 * This compatibility layer will be maintained through version 3.x and removed in 4.0.0.
 */
// Re-export everything from core for backward compatibility
export { 
// Utility functions
correlationIdSetPrefix, correlationIdGetPrefix, correlationIdCanIncludeCorrelationHeader, correlationIdGetCorrelationContext, correlationIdGetCorrelationContextValue, dateTimeUtilsNow, dateTimeUtilsDuration, isInternalApplicationInsightsEndpoint, createDistributedTraceContextFromTrace, 
// Throttle manager
ThrottleMgr, 
// Connection string parsing
parseConnectionString, ConnectionStringParser, DistributedTracingModes, EventPersistence, SeverityLevel, RequestHeaders, 
// Constants
DisabledPropertyName, ProcessLegacy, SampleRate, HttpMethod, DEFAULT_BREEZE_ENDPOINT, DEFAULT_BREEZE_PATH, strNotSpecified, 
// Telemetry classes
Envelope, Event, Exception, Metric, PageView, PageViewPerformance, RemoteDependencyData, Trace, Data, dataSanitizeKeyAndAddUniqueness, dataSanitizeKey, dataSanitizeString, dataSanitizeUrl, dataSanitizeMessage, dataSanitizeException, dataSanitizeProperties, dataSanitizeMeasurements, dataSanitizeId, dataSanitizeInput, dsPadNumber, ConfigurationManager, ContextTagKeys, CtxTagKeys, Extensions, 
// Data types
EventDataType, ExceptionDataType, MetricDataType, PageViewDataType, PageViewPerformanceDataType, RemoteDependencyDataType, RequestDataType, TraceDataType, 
// Envelope types
EventEnvelopeType, ExceptionEnvelopeType, MetricEnvelopeType, PageViewEnvelopeType, PageViewPerformanceEnvelopeType, RemoteDependencyEnvelopeType, RequestEnvelopeType, TraceEnvelopeType, 
// Telemetry creation
TelemetryItemCreator, createTelemetryItem, 
// Helper functions
stringToBoolOrDefault, msToTimeSpan, getExtensionByName, isCrossOriginError, 
// Trace parent functions (re-exported from core)
createTraceParent, parseTraceParent, isValidTraceId, isValidSpanId, isValidTraceParent, isSampledFlag, formatTraceParent, findW3cTraceParent, findAllScripts, isBeaconsSupported as isBeaconApiSupported, 
// DOM helpers
createDomEvent, 
// Storage helpers
utlDisableStorage, utlEnableStorage, utlCanUseLocalStorage, utlGetLocalStorage, utlSetLocalStorage, utlRemoveStorage, utlCanUseSessionStorage, utlGetSessionStorageKeys, utlGetSessionStorage, utlSetSessionStorage, utlRemoveSessionStorage, utlSetStoragePrefix, 
// URL helpers
urlParseUrl, urlGetAbsoluteUrl, urlGetPathName, urlGetCompleteUrl, urlParseHost, urlParseFullHost, createOfflineListener, 
// Plugin identifiers
PropertiesPluginIdentifier, BreezeChannelIdentifier, AnalyticsPluginIdentifier } from "@microsoft/applicationinsights-core-js";
//# sourceMappingURL=applicationinsights-common.js.map